
import {defineComponent, PropType} from "vue";
import "vue3-carousel/dist/carousel.css";
import {Content} from "../../views/content/helpers";

export default defineComponent({
  name: "ModalIntroductoryContent",
  props: {
    introductoryContent: {
      type: Object as PropType<Content>,
      required: true,
    },
  },
  setup(props, { emit }) {
    document.addEventListener("keydown", function(e) {
      if (e.key === "Escape") {
        emit("close");
      }
    });
  }
});
